// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer[data-v-1deec271]{background:#000;color:#fff;font-size:.9rem}.separator[data-v-1deec271]{position:relative;padding:0 1rem}.separator[data-v-1deec271]:before{content:\"\";position:absolute;top:0;bottom:0;left:40%;width:1px;height:100%;transform:translateX(-50%);border-right:1px solid hsla(0,0%,100%,.3)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
